import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-skeletal',
  imports: [CommonModule],
  standalone: true,
  template: `
          <div class="skeleton p-0 m-0">
            <ng-container *ngFor="let row of getCardChunks()">
              <div class="skeleton_card_section" [ngStyle]="{ columnGap: cardGap + 'px',marginBottom: cardGap + 'px' }">
                  <ng-container *ngFor="let field of row">
                    <div class="skeleton_card_item">
                      <div class="line skeleton_card_item_field" [ngStyle]="{ height: cardHeight + 'px' }"></div>
                    </div>
                  </ng-container>
              </div>
            </ng-container>
          </div>
  `,
  styles: [`
      .skeleton_card_item {
        flex: 1 1 auto;
        flex-direction: column;
      }

      .border_radius_6{
        border-radius: 6px;
      }

      .skeleton_card_section {
        display: flex;
        flex-direction: row;
      }
      .skeleton_card_item_field{
        height: 35px;
        border-radius: 4px;
      }
    `]
})
export class CardSkeletalComponent {
  @Input() rows: number = 3;
  @Input() cardsPerRow: number = 4;
  @Input() cardHeight: number = 40;
  @Input() cardGap: number = 15;

  constructor() { }

  ngOnInit(): void { }

  getCardChunks(): number[][] {
    const totalCards = Array.from({ length: this.rows * this.cardsPerRow }, (_, i) => i);
    const chunks = [];
    for (let i = 0; i < totalCards.length; i += this.cardsPerRow) {
      chunks.push(totalCards.slice(i, i + this.cardsPerRow));
    }
    return chunks;
  }
}
